/* --------------------------------------------------------------------------
	Header
-------------------------------------------------------------------------- */

/* globals jQuery, Site */

(function ($, Site) {
	var Raf, LastScrollTop;

	function init() {
		if (!$('.js-header').length) {
			return;
		}

		Raf = window.requestAnimationFrame;
		LastScrollTop = window.pageYOffset;

		scrollLoop();
		onScroll();

		Site.OnResize.push(onResize);
	}

	function scrollLoop() {
		var scrollTop = window.pageYOffset;

		if (LastScrollTop === scrollTop) {
			Raf(scrollLoop);

			return;
		} else {
			LastScrollTop = scrollTop;

			onScroll();
			Raf(scrollLoop);
		}
	}

	function onScroll() {
		var headerScroll = $('.js-header-inner')[0].getBoundingClientRect().top;

		if ($(window).width() >= Site.MinLG) {
			if (headerScroll > -100) {
				$('.header_decoration_dot').css('opacity', 1);
				$('.header_primary_inner').css('border-bottom-color', 'rgba(255, 255, 255, 0.15)');
				$('.header_decoration_line').css('width', '48px');
				$('.js-header-screen').css('opacity', 0);
				$('.header .logo_link').css('padding-bottom', '35px');
				$('.header .icon_logo').css('width', '200px');
				$('.micro_header_site').css('margin-bottom', '-2px');
				$('.micro_header_divider').css('margin-bottom', '15px');
			} else if (headerScroll < -100 && headerScroll > -300) {
				var opacity = 1 - (Math.abs(headerScroll) - 100) / 200;
				var border = opacity * 0.15;
				var width = opacity * 48;

				$('.header_decoration_dot').css('opacity', opacity);
				$('.header_primary_inner').css('border-bottom-color', 'rgba(255, 255, 255, ' + border + ')');
				$('.header_decoration_line').css('width', width + 'px');
				$('.js-header-screen').css('opacity', 1 - opacity);
				$('.header .logo_link').css('padding-bottom', 35 - 15 * (1 - opacity) + 'px');
				$('.header .icon_logo').css('width', 200 - 43 * (1 - opacity) + 'px');
				$('.micro_header_site').css('margin-bottom', -2 - 6 * (1 - opacity) + 'px');
				$('.micro_header_divider').css('margin-bottom', 15 - 6 * (1 - opacity) + 'px');
			} else {
				$('.header_decoration_dot').css('opacity', 0);
				$('.header_primary_inner').css('border-bottom-color', 'rgba(255, 255, 255, 0)');
				$('.header_decoration_line').css('width', '0');
				$('.js-header-screen').css('opacity', 1);
				$('.header .logo_link').css('padding-bottom', '20px');
				$('.header .icon_logo').css('width', '157px');
				$('.micro_header_site').css('margin-bottom', '-8px');
				$('.micro_header_divider').css('margin-bottom', '9px');
			}

			if (headerScroll < 0) {
				$('.js-header').addClass('pin');
			} else {
				$('.js-header').removeClass('pin');
			}
		} else {
			$('.header_decoration_dot').css('opacity', 1);
			$('.header_primary_inner').css('border-bottom-color', 'rgba(255, 255, 255, 0.15)');
			$('.header_decoration_line').css('width', '27px');
			$('.js-header-screen').css('opacity', 0);
			$('.header .logo_link').css('padding-bottom');
			$('.header .icon_logo').css('width');
			$('.micro_header_site').css('margin-bottom');
			$('.micro_header_divider').css('margin-bottom');
		}
	}

	function onResize() {
		onScroll();
	}

	Site.OnInit.push(init);
})(jQuery, Site);
